import { ReactNode } from "react";

import { Spinner } from "@bps/fluent-ui";
import { ConditionModalFormValues } from "@modules/booking/screens/booking-calendar/components/appointment-dialog/components/appointment-form/condition-modal/Condition.types.ts";
import { ConditionHelper } from "@modules/booking/screens/booking-calendar/components/appointment-dialog/components/appointment-form/context/ConditionHelper.ts";
import { Claim } from "@stores/acc/models/Claim.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { DataFetcher } from "@ui-components/data-fetcher/DataFetcher.tsx";

interface ConditionHelperDataFetcherProps {
  claim: Claim;
  showModal?: boolean;
  children: (helper: ConditionHelper) => ReactNode;
}

export const ClaimConditionHelperDataFetcher: React.FC<
  ConditionHelperDataFetcherProps
> = ({ claim, showModal, children }) => {
  const root = useStores();
  const { acc, clinical } = root;

  const getCondition = async (): Promise<ConditionHelper> => {
    const claimEpisodesOfCare = await acc.getClaimEpisodesOfCare({
      claimIds: [claim.id]
    });

    const episodeOfCare = claimEpisodesOfCare.length
      ? await clinical.getEpisodeOfCare(claimEpisodesOfCare[0].episodeOfCareId)
      : undefined;

    await claim.loadClaimSchedules();

    const conditionHelper = new ConditionHelper(root, claim.patientId!, {
      onSubmit: async (
        values: ConditionModalFormValues,
        helper: ConditionHelper
      ) => {
        await helper.submitUpdateConditionValues(
          values,
          values.referralIn ? claim.providerId : undefined
        );
      },
      episodeOfCare
    });

    if (showModal) {
      conditionHelper.showConditionModal(false);
    }

    return conditionHelper;
  };

  return (
    <DataFetcher<ConditionHelper> fetch={getCondition} fallback={<Spinner />}>
      {helper => children(helper)}
    </DataFetcher>
  );
};
